<template>
    <div class="game-page">
        <div class="game-title"></div>
        <div class="game-section">
            <IndexGame></IndexGame>
        </div>
    </div>
</template>
<script>
import IndexGame from './subPage/IndexGame.vue'

export default {
    name: 'GamePage',
    components: { IndexGame },
    mounted() {
        $('body').addClass('game-bg')
        $('#app').css('overflow', 'hidden')
    },
    beforeDestroy() {
        $('#app').css('overflow', 'initial')
        $('body').removeClass('game-bg')
    }
}
</script>
<style lang="less" scoped>
.game-page {
    margin: 0 auto;
    height: 100%;
    padding-top: 140px;
    width: @main-width;

    .game-title {
        margin: 0 auto 47px;
        width: 534px;
        height: 62px;
        background: url(../../assets/database-txt.png) center/100% no-repeat;
    }

    .game-section {
        height: calc(100% - 109px);

        /deep/ .rec-game-item-comp {
            margin-right: 40px !important;
            margin-bottom: 40px !important;

            &:nth-child(4n) {
                margin-right: 0 !important;
            }
        }
    }
}
</style>
